import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ISearchItem } from 'bi-interfaces';
import { BIModulesService } from '../../bi-modules.service';

@Component({
  selector: 'bi-search',
  templateUrl: './bi-search.component.html',
  styleUrls: ['./bi-search.component.scss']
})
export class BISearchComponent implements OnInit {
   
  @Output() searchChanges = new EventEmitter();
  @Input() searchDataList: ISearchItem[] = [];
  @Input() searchReportManagerList: ISearchItem[] = [];

  public searchFormControl: FormControl = new FormControl();
  private filteredData: ISearchItem[] = [];

  constructor(public translateService: TranslateService,
    public biService: BIModulesService
  ) {
  }

  ngOnInit(): void {
    this.searchFormControl.valueChanges
    .pipe(
      distinctUntilChanged(),
      debounceTime(400)
    ).subscribe(value => {
      this.handleFilter(value);
    })
  }

  public resetControl() {
    if (this.searchFormControl.value) this.searchFormControl.reset();
  }

  private handleFilter(search: string) {
    if (search) {
      this.filteredData = this.searchDataList.filter(item => ((this.translateService.instant(item.text)).toLowerCase().indexOf(search.toLowerCase()) !== -1)); 
    }
    else this.filteredData = [];

    this.searchChanges.emit({value: (search ?? ''), searchResults: this.filteredData});
  }
}
